import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "aviaRoute__info"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("div", { class: "aviaRoute__info__ico icoBag" }),
  /*#__PURE__*/_createTextVNode(" 10 кг ручная кладь ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "aviaRoute__info__ico icoBagage" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "aviaRoute__info__ico time" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "aviaRoute__info__ico airSmall" }, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_ctx.infoData)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("ul", null, [
          _hoisted_2,
          _createVNode("li", null, [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.infoData.baggage) + " багаж ", 1 /* TEXT */)
          ]),
          _createVNode("li", null, [
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(_ctx.infoData.time), 1 /* TEXT */)
          ]),
          _createVNode("li", null, [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(_ctx.infoData.plane) + " | " + _toDisplayString(_ctx.infoData.operatin) + " " + _toDisplayString(_ctx.infoData.codePlane) + " | " + _toDisplayString(_ctx.infoData.number), 1 /* TEXT */)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}